import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation ConfirmWorkOrder($input: ConfirmWorkOrderInput!) {
    inventoryAdjustment {
      confirmWorkOrder(input: $input) {
        __typename
        ... on ConfirmWorkOrderSuccess {
          inventoryAdjustment {
            inventoryAdjustmentId
            status
          }
        }
        ... on ConfirmWorkOrderFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
